import { type AxiosError, isAxiosError } from "axios";
import type { ProblemDetails, ValidationProblemDetails } from "./swagger-types/v1/index.js";

export const commonResponsesTypeGuards = {
  is500Response: (error: any): error is AxiosError<ProblemDetails> => {
    return isAxiosError(error) && error.response?.status === 500;
  },
  is400Response: (error: any): error is AxiosError<ValidationProblemDetails> => {
    return isAxiosError(error) && error.response?.status === 400;
  },
  isNetworkError: (error: any): error is AxiosError => {
    return isAxiosError(error) && !error.response;
  },
} as const;
